import { MultiSelect } from "@/components/ui/multi-select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";

interface TrainingFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
}

export function TrainingFields({
  profile,
  setProfile,
  readOnly
}: TrainingFieldsProps) {
  return (
    <div className="space-y-1">
      <div className="flex items-center gap-1">
        <label className="text-sm font-medium">Weiterbildung</label>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <HelpCircle className="h-4 w-4 text-gray-400" />
            </TooltipTrigger>
            <TooltipContent>
              <p>Welche Weiterbildungen hast du?</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>

      <MultiSelect
        disabled={readOnly}
        options={[
          {
            value: "intensivpflege",
            label: "Außerklinische Intensiv- und Beatumungspflege"
          },
          {
            value: "heimleitung",
            label: "Heimleitung/Einrichtungsleitung"
          },
          { value: "intensiv", label: "Intensiv- und Anästhesiepflege" },
          { value: "onkologie", label: "Onkologie" },
          { value: "operation", label: "Operations- und Endoskopiedienst" },
          { value: "palliativ", label: "Palliativpflege" },
          { value: "pdl", label: "Pflegedienstleitung" },
          { value: "praxisanleitung", label: "Praxisanleitung" },
          {
            value: "psychiatrie",
            label: "Psychiatrie / Gerontopsychiatrie"
          },
          { value: "qm", label: "Qualitätsmanagement" },
          { value: "wbl", label: "Wohnbereichsleitung" },
          { value: "wundmanagement", label: "Wundmanagement" }
        ]}
        selectedValues={profile?.advanced_training || []}
        onValueChange={(values) =>
          setProfile({ ...profile!, advanced_training: values })
        }
        placeholder="Weiterbildung auswählen"
        maxCount={3}
      />
    </div>
  );
}
